import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import '../../design/header.css';

const Header = () => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      setIsLoggedIn(true); 
      const fetchUserData = async () => {
        try {
          const response = await axios.get("https://api.deliquentauction.com/auth/protected-route/", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setUser(response.data); 
        } catch (error) {
          console.error("Error fetching user data", error);
        }
      };
      fetchUserData();
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    setIsLoggedIn(false);
    setUser(null);
    navigate("/landing")
  };

  return (
    <div>
      <header>
        <nav>
          <a href="/">
            <img src="/logo.png" alt="Logo" />
          </a>
          <div className="user-info">
            {isLoggedIn && user ? (
              <>
                <span className="user">{user.username}</span>
                <button className="sign-out" onClick={handleLogout}>Sign Out</button>
              </>
            ) : (
              <span>Not Logged In</span>
            )}
          </div>
        </nav>
      </header>
  
      <div className="pages-container">
        <div className="pages">
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/leads">Properties</Link>
          <Link to="/subscriptions">Subscriptions</Link>
          <Link to="/about">About Us</Link>
        </div>
      </div>
    </div>
  );
};

export default Header;